import { render, staticRenderFns } from "./HeroPage.vue?vue&type=template&id=33187e8a&scoped=true&"
import script from "./HeroPage.vue?vue&type=script&lang=js&"
export * from "./HeroPage.vue?vue&type=script&lang=js&"
import style0 from "./HeroPage.vue?vue&type=style&index=0&id=33187e8a&lang=scss&scoped=true&"
import style1 from "./HeroPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33187e8a",
  null
  
)

export default component.exports